module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plain-banner"
  }, [_c('h1', {
    staticClass: "plain-banner__title title--general title--1"
  }, [_vm._v("Device limit exceeded")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__container"
  }, [_c('v-layout', {
    staticClass: "plain-banner__description",
    attrs: {
      "justify-space-between": "",
      "column": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "plain-banner__row"
  }, [_vm._v("Your current subscription supports " + _vm._s(_vm.maxDevices) + " devices.")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__row"
  }, [_vm._v("Please upgrade your plan in order to add new device.")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "button",
      "to": {
        name: 'plans'
      },
      "color": "#145cff",
      "dark": ""
    }
  }, [_vm._v("\n\t\t\tPlans and pricing\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75cfc9a4","hasScoped":false}!./app/components/device-limit-exceeded/template.html
// module id = 394
// module chunks = 0